export const NOT_ASSIGNED = {
    value: -1,
    label: "Sin Asignar"
}